/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Kind_ListingInputs */

const cs_pipelines_kind_listing = /** @type {(inputs: Pipelines_Kind_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabídky`)
};

const en_pipelines_kind_listing = /** @type {(inputs: Pipelines_Kind_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listings`)
};

/**
* | output |
* | --- |
* | "Listings" |
*
* @param {Pipelines_Kind_ListingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_kind_listing = /** @type {((inputs?: Pipelines_Kind_ListingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Kind_ListingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_kind_listing(inputs)
	return cs_pipelines_kind_listing(inputs)
});